import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/** Whether the CUBE AI panel is open (toggled from the header CUBE AI icon). */
const showCubeAiSlice = createSlice({
  name: "showCubeAi",
  initialState: false,
  reducers: {
    setShowCubeAi: (_state: boolean, action: PayloadAction<boolean>) => action.payload,
  },
});

export const { setShowCubeAi } = showCubeAiSlice.actions;

export const showCubeAi = showCubeAiSlice.reducer;
